export default {
    edit: 'Rediģēt',
    location: 'Atrašanās vieta + Noteikumi un nosacījumi',
    filter: 'Filtrs',
};
